/** Badge + reason copy when Ace mirrored the reviewer's answer. */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCheck } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import { aceDeferredReasonText } from "./aceDeferredToHuman";

export function AceAgreedWithYouBadge({ compact = false }: { compact?: boolean }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md bg-slate-500/15 text-slate-300 ring-1 ring-slate-400/25 ${
        compact ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]"
      }`}
      data-testid="ace-agreed-with-you"
    >
      <FontAwesomeIcon icon={faUserCheck} className="text-slate-400" aria-hidden />
      Agreed with you
    </span>
  );
}

export function AceDeferredReason({ reason }: { reason?: string | null }) {
  return (
    <p className="text-slate-500 leading-relaxed" data-testid="ace-deferred-reason">
      <span className="text-slate-400 font-medium">Couldn&apos;t verify independently:</span>{" "}
      {aceDeferredReasonText(reason)}
    </p>
  );
}
